import {
  createApiFactory,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { OnboardSquadsApiRef } from './apis/onboardSquadsApi';
import { OnboardSquadsClient } from './apis/onboardSquadsClient';

export const onboardSquadsPlugin = createPlugin({
  id: 'onboard-squads',
  apis: [
    createApiFactory({
      api: OnboardSquadsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new OnboardSquadsClient({ discoveryApi, fetchApi }),
    }),
  ],
});
